import {
  getSectionsForType,
  SectionKey,
} from 'src/modules/campaignConfigBuilder/registry/sectionRegistry';
import { CampaignConfigType } from 'src/modules/campaignConfigBuilder/types';

// Config sections whose settings buildPresetContent cannot persist. A preset
// only carries scheduledMessages/keywords/opt-out/audience/appointmentType, so
// types that own state in these sections (recurring schedule, text-to-win prize
// config) would silently save an empty template.
// Until presets support those settings, hide "Save as custom template"
// for such types rather than produce a lossy preset.
const UNPERSISTABLE_SECTIONS: SectionKey[] = ['recurringSettings', 'textToWinSettings'];

export function canSaveTypeAsPreset(campaignType: string): boolean {
  const sections = getSectionsForType(campaignType as CampaignConfigType);
  return !sections.some(section => UNPERSISTABLE_SECTIONS.includes(section));
}
